<section>
  <h2>Neue Person anlegen</h2>
  <button type="button" class="new-person-button" (click)="goToSearch()">
    Person bearbeiten/suchen
  </button>

  @if (error) {
    <p class="errorMessage">{{ error }}</p>
  }

  <div class="editPersonWrapper">
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="givn">Vorname</label>
        <input id="givn" type="text" [(ngModel)]="givn" />
      </div>
      <div class="editPersonBox">
        <label for="surn">Nachname (geb.)</label>
        <input id="surn" type="text" [(ngModel)]="surn" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="nameRufname">Rufname</label>
        <input id="nameRufname" type="text" [(ngModel)]="nameRufname" />
      </div>
      <div class="editPersonBox">
        <label for="nameNick">Spitzname</label>
        <input id="nameNick" type="text" [(ngModel)]="nameNick" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="nameNpfx">Namenspräfix</label>
        <input id="nameNpfx" type="text" [(ngModel)]="nameNpfx" />
      </div>
      <div class="editPersonBox">
        <label for="nameMarnm">Ehename (verh.)</label>
        <input id="nameMarnm" type="text" [(ngModel)]="nameMarnm" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="sex">Geschlecht</label>

        <select id="sex" [(ngModel)]="sex">
          <option value="F">weiblich</option>
          <option value="M">männlich</option>
          <option value="D">divers</option>
        </select>
      </div>
      <div class="editPersonBox">
        <label for="occu">Beruf</label>
        <input id="occu" type="text" [(ngModel)]="occu" />
      </div>
    </div>

    <h3>Geburts- und Sterbedaten</h3>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="birtDate">Geburtsdatum</label>
        <input
          id="birtDate"
          type="text"
          [(ngModel)]="birtDate"
          placeholder="z. B. 12.03.1847 oder nach 1389"
        />
      </div>
      <div class="editPersonBox">
        <label for="birtPlac">Geburtsort</label>
        <input id="birtPlac" type="text" [(ngModel)]="birtPlac" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="deatDate">Sterbedatum</label>
        <input
          id="deatDate"
          type="text"
          [(ngModel)]="deatDate"
          placeholder="z. B. 12.03.1847 oder nach 1389"
        />
      </div>
      <div class="editPersonBox">
        <label for="deatPlac">Sterbeort</label>
        <input id="deatPlac" type="text" [(ngModel)]="deatPlac" />
      </div>
    </div>

    <h3>Taufe und Beerdigung</h3>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="reli">Religion</label>
        <input id="reli" type="text" [(ngModel)]="reli" />
      </div>
      <div class="editPersonBox">
        <label for="chrAddr">Taufadresse</label>
        <input id="chrAddr" type="text" [(ngModel)]="chrAddr" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="chrDate">Taufdatum</label>
        <input
          id="chrDate"
          type="text"
          [(ngModel)]="chrDate"
          placeholder="z. B. 12.03.1847 oder nach 1389"
        />
      </div>
      <div class="editPersonBox">
        <label for="chrPlac">Taufort</label>
        <input id="chrPlac" type="text" [(ngModel)]="chrPlac" />
      </div>
    </div>
    <div class="editPersonTwoBoxes">
      <div class="editPersonBox">
        <label for="buriDate">Beerdigungsdatum</label>
        <input
          id="buriDate"
          type="text"
          [(ngModel)]="buriDate"
          placeholder="z. B. 12.03.1847 oder nach 1389"
        />
      </div>
      <div class="editPersonBox">
        <label for="buriPlac">Beerdigungsort</label>
        <input id="buriPlac" type="text" [(ngModel)]="buriPlac" />
      </div>
    </div>
    <h3>Stammbaum (verpflichtend)</h3>
    <div class="editPersonBox red">
      <label for="family">Stammbaum *</label>

      @if (availableFamilies.length > 1) {
        <select id="family" [(ngModel)]="selectedFamily" name="family">
          <option value="">Bitte auswählen</option>

          @for (family of availableFamilies; track family) {
            <option [value]="family">
              {{ getFamilyLabel(family) }}
            </option>
          }
        </select>
      } @else {
        <input id="family" type="text" [value]="getFamilyLabel(selectedFamily)" readonly />
      }
    </div>
    <h3>Vertraulichkeit</h3>
    <div>
      <div class="editPersonBox">
        <label for="confidential">Vertraulichkeit</label>

        <select id="confidential" [(ngModel)]="confidential">
          <option value="restricted">Eingeschränkt</option>
          <option value="no">Nein</option>
          <option value="yes">Ja</option>
        </select>
      </div>
      <br />
      <i>
        Hinweis: Vertraulichkeit <i>ja</i> bedeutet, dass nichts von dieser
        Person angezeigt wird und sie als <i>vertraulich</i> im Staummbaum
        dargestellt wird. Bei <i>eingeschränkt</i> wird nur der Name angezeigt.
        Als Standard ist bei allen lebenden Personen
        <i>eingeschränkt</i> hinterlegt, es sei denn, es wurde anders gewünscht.
        Bitte nutzt dieses Feld mit Bedacht.
      </i>
    </div>

    <div class="editRelationSection">
      <h3>Verwandtschaften</h3>
      <i>
        Alle Verknüpfungen mit Verwandten erfolgen im nächsten Schritt (Person
        bearbeiten).
      </i>
    </div>

    <h3>Quellen und Notizen</h3>
    <div class="textBox">
      <label for="note">Quellen</label>
      <textarea id="note" [(ngModel)]="sour" rows="6"></textarea>
    </div>
    <div class="textBox">
      <label for="note">Notizen</label>
      <textarea id="note" [(ngModel)]="note" rows="6"></textarea>
    </div>

    <div>
      <h4>Bilder:</h4>

      <h5>Bilder hochladen (max. 6):</h5>

      @for (index of [1, 2, 3, 4, 5, 6]; track index) {
        <div class="imageUploadContainer">
          <div class="uploadImageField">
            <label [for]="'image' + index"> Bild {{ index }} </label>

            <input
              type="file"
              [id]="'image' + index"
              (change)="onImageFileChange($event, index)"
              accept=".jpg,.jpeg,.png"
            />
          </div>
          <div class="previewBox">
            @if (imagePreviews[index - 1]) {
              <div
                class="previewImage"
                (click)="removeImagePreview(index)"
                title="Bild entfernen"
              >
                <img
                  [src]="imagePreviews[index - 1]"
                  alt="Vorschau"
                  [id]="'preview' + index"
                  width="100"
                />
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="buttonBox">
    <button type="button" (click)="cancel()">Abbrechen</button>
    <button type="button" (click)="save()">Speichern</button>
  </div>

  @if (showSaveConfirmation) {
    <div class="popUpConfirmation">
      <div class="popUpConfirmationContent">
        <h3>Anlage bestätigen</h3>

        <p>Folgende Person wird gespeichert:</p>
        @if (this.noNewChanges) {
          <b>Keine Änderungen</b>
          <br /><br />
        }

        @if (!this.noNewChanges) {
          <ul>
            @for (change of pendingChanges; track change.label) {
              <li>
                <strong>{{ change.label }}:</strong>
                <span> {{ change.newValue }} </span>
              </li>
            }
          </ul>
        }

        <div class="buttonBox">
          <button type="button" (click)="cancelSave()">Abbrechen</button>

          <button type="button" (click)="confirmSave()">
            Änderungen speichern
          </button>
        </div>
      </div>
    </div>
  }

  @if (personPopupOpen) {
    <div class="popupOverlay" (click)="closePersonPopup()">
      <div class="personPopup" (click)="$event.stopPropagation()">
        <div class="personPopupHeader">
          <h3>
            @if (personPopupPerson) {
              Person ändern
            } @else {
              Person hinzufügen
            }
          </h3>
        </div>

        @if (personPopupPerson) {
          <div class="selectedPerson">
            <div class="selectedPersonName">
              {{ personPopupPerson.name }}
            </div>

            <div class="selectedPersonRefn">({{ personPopupPerson.refn }})</div>
          </div>
        }

        <div class="personSearch">
          <label for="personSearch"> Person suchen </label>

          <input
            id="personSearch"
            type="text"
            [(ngModel)]="personSearchTerm"
            (input)="searchPersons()"
            placeholder="Name oder REFN suchen ..."
          />
        </div>
        @if (personSearchLoading) {
          <div class="personSearchLoading">Suche läuft ...</div>
        } @else if (personSearchResults.length > 0) {
          <div class="personSearchResults">
            @for (person of personSearchResults; track person.refn) {
              <div
                class="personSearchResult"
                [class.selected]="
                  personPopupSelectedPerson?.refn === person.refn
                "
                (click)="selectPerson(person)"
              >
                <div class="selectedPerson">
                  <div class="selectedPersonName">
                    {{ person.name }}
                  </div>

                  <div class="selectedPersonRefn">
                    {{ person.refn }}
                  </div>
                </div>
              </div>
            }
          </div>
        } @else if (personSearchTerm.trim()) {
          <div class="emptyRelations">Keine Person gefunden.</div>
        }
        <br />
        <div class="buttonBox">
          <button type="button" (click)="closePersonPopup()">Abbrechen</button>
          <button
            type="button"
            class="deleteButton"
            (click)="removePersonFromPopup()"
          >
            Person entfernen
          </button>
          <button
            type="button"
            (click)="savePersonPopup()"
            [disabled]="!personPopupSelectedPerson"
          >
            Hinzufügen
          </button>
        </div>
      </div>
    </div>
  }

  @if (showSuccessPopup) {
    <div class="popUpConfirmation">
      <div class="popUpConfirmationContent">
        <h2>Person erfolgreich angelegt</h2>

        <p>{{ successMessage }}</p>

        <div class="buttonBox">
          <button type="button" (click)="goToCreatedPerson()">
            Person bearbeiten
          </button>

          <button type="button" (click)="goToNewPerson()">
            Neue Person anlegen
          </button>
        </div>
      </div>
    </div>
  }

  @if (showExistingPersonPopup) {
    <div class="popUpConfirmation">
      <div
        class="popUpConfirmationContent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="existing-person-title"
      >
        <h2 id="existing-person-title">
          Person möglicherweise bereits vorhanden
        </h2>

        <p>
          Es gibt bereits Personen mit diesem Vor- und Nachnamen. Bitte prüfe,
          ob eine davon dieselbe Person ist.
        </p>

        <div class="existing-person-list">
          @for (person of existingPersons; track person.refn) {
            <div class="existing-person-item">
              <div class="existing-person-details">
                <strong> {{ person.givn }} {{ person.surn }} </strong>

                <span> REFN: {{ person.refn }} </span>

                @if (person.birt_date) {
                  <span> Geboren: {{ person.birt_date }} </span>
                }

                @if (person.deat_date) {
                  <span> Verstorben: {{ person.deat_date }} </span>
                }

                @if (!person.birt_date && !person.deat_date) {
                  <span> Keine Geburts- oder Sterbedaten vorhanden </span>
                }
              </div>

              <button type="button" (click)="openExistingPerson(person)">
                Person öffnen
              </button>
            </div>
          }
        </div>

        <div class="buttonBox">
          <button
            type="button"
            class="secondary-button"
            (click)="cancelExistingPersonCheck()"
          >
            Abbrechen
          </button>

          <button type="button" (click)="createAnyway()">
            Trotzdem neu anlegen
          </button>
        </div>
      </div>
    </div>
  }
</section>

<app-scroll-to-top-button></app-scroll-to-top-button>
